import React, { useState, useEffect, useRef } from 'react';
import { useLocation,useNavigate } from 'react-router-dom'; // For accessing state
import io from 'socket.io-client';
import Message from './Message'; // Your existing Message component
import { MdDownloadForOffline } from 'react-icons/md';
import { RiChatNewLine } from 'react-icons/ri';
import '../styles/ChatBox.css';
import { jsPDF } from 'jspdf';
import loadingGif from '../assets/Loving-Is-Loading-gif.gif'
import {  MdOutlineFileDownload } from "react-icons/md";
import { HiArrowSmUp } from "react-icons/hi";
import sendIcon from '../assets/send-icon.svg'


const SOCKET_SERVER_URL = process.env.REACT_APP_BACKEND_URL;

const UnauthenticatedChat = () => {
  const location = useLocation(); // Get state from navigation
  const initialMessage = location.state?.input || ''; // Extract initial message from state
  const [socket, setSocket] = useState(null);
  const [chatId, setChatId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loadingMessage, setLoadingMessage] = useState(false);
  const messagesEndRef = useRef(null);
  const messageRef = useRef(null);
  const navigate = useNavigate()

  console.log(messageRef);
  console.log(chatId);
  
  useEffect(() => {
    if (messageRef.current) {
        console.log('Messages container:', messageRef.current);
        const messageElements = messageRef.current.querySelectorAll('.message');
        messageElements.forEach((message) => console.log('Message:', message.textContent));
    }
}, [messages]);


  useEffect(() => {
    const newSocket = io(SOCKET_SERVER_URL, { transports: ['websocket'] });
    setSocket(newSocket);

    newSocket.on('connect', () => {
      newSocket.emit('initChat', { isGuest: true }, (response) => {
        if (response.chatId) {
          setChatId(response.chatId);

          // Send the initial message if provided
          if (initialMessage) {
            sendMessageOnInit(newSocket, response.chatId, initialMessage);
          }
        }
      });
    });

    return () => {
      newSocket.disconnect();
    };
  }, [initialMessage]);

  const sendMessageOnInit = (socket, chatId, message) => {
    if (!message.trim() || !socket || !chatId) return;

    const userMessage = { sender: 'user', text: message.trim() };
    setMessages((prev) => [...prev, userMessage]);
    setLoadingMessage(true);

    socket.emit('sendMessage', { chatId, message: userMessage.text }, (response) => {
      setLoadingMessage(false);

      if (response.error) {
        setMessages((prev) => [
          ...prev,
          { sender: 'assistant', text: 'Sorry, something went wrong.' },
        ]);
      } else {
        setMessages((prev) => [
          ...prev,
          { sender: 'assistant', text: response.message.trim() },
        ]);
      }
    });
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (!input.trim() || !socket || !chatId) return;

    const userMessage = { sender: 'user', text: input.trim() };
    setMessages((prev) => [...prev, userMessage]);
    setLoadingMessage(true);

    socket.emit('sendMessage', { chatId, message: userMessage.text }, (response) => {
      setLoadingMessage(false);

      if (response.error) {
        setMessages((prev) => [
          ...prev,
          { sender: 'assistant', text: 'Sorry, something went wrong.' },
        ]);
      } else {
        setMessages((prev) => [
          ...prev,
          { sender: 'assistant', text: response.message.trim() },
        ]);
      }
    });

    setInput('');
  };

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const handleTextareaResize = (e) => {
    const textarea = e.target;
    textarea.style.height = "auto"; // Reset height to calculate scrollHeight
    textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`; // Limit to 150px max
};


    const getHeading = () => {
        const element = messageRef.current;
        if (!element) return "Untitled";
    
        const headings = element.querySelectorAll("h1, h2, h3, h4, h5, h6");
        return headings.length > 0 ? headings[0].textContent.trim() : "Untitled";
      };
      const handleDownloadPDF = () => {
        const doc = new jsPDF();
        const heading = getHeading(); // Title of the document
        const element = messageRef.current;
        if (!element) {
          console.error("Message content is not available!");
          return;
        }
      
        // Set document metadata and heading
        doc.setProperties({ title: heading });
        doc.setFontSize(18);
        doc.setFont("Helvetica", "bold");
        doc.text(heading, 10, 20);
      
        const messages = element.innerText.trim().split("\n").map(line => line.trim());
        const pageHeight = doc.internal.pageSize.height;
        const margin = 10;
        const maxLineWidth = doc.internal.pageSize.width - margin * 2;
        let yPosition = 30;
      
        // Add messages to the PDF
        messages.forEach((line) => {
          if (!line) return; // Skip empty lines
      
          // Set font for normal text
          doc.setFontSize(12);
          doc.setFont("Helvetica", "normal");
          const wrappedText = doc.splitTextToSize(line, maxLineWidth);
      
          // Check for page overflow
          wrappedText.forEach((textLine) => {
            if (yPosition + 10 > pageHeight - margin) {
              addFooter(doc, pageHeight, margin);
              doc.addPage();
              yPosition = margin + 10;
            }
            doc.text(textLine, margin, yPosition);
            yPosition += 8; // Line height
          });
        });
      
        // Add footer and save the PDF
        addFooter(doc, pageHeight, margin);
        doc.save(`${heading}.pdf`);
      };
      
      // Helper function to add footer
      const addFooter = (doc, pageHeight, margin) => {
        doc.setFontSize(10);
        doc.setFont("Helvetica", "normal");
        const footerText = "Generated with YourApp";
        const textWidth = doc.getTextWidth(footerText);
        doc.text(footerText, (doc.internal.pageSize.width - textWidth) / 2, pageHeight - margin);
      };
      
  return (
    <div className="chat-container">
      <div className="sidebar">
        <div className="sidebar-nav">
          <button className="add-chat-button" onClick={()=>navigate('/login')}>
            <RiChatNewLine size={20} />
          </button>
        </div>
      </div>
      <div className="chat-area">
        <div className="messages"  ref={messageRef}>
          {messages.map((msg, index) => (
            <Message key={index} sender={msg.sender} text={msg.text} />
          ))}
                              {loadingMessage && (
                  <div className="message loading">
                      <img src={loadingGif} alt="Loading..." />
                  </div>
              )}
          <div ref={messagesEndRef} />
        </div>
<form className="input-area" onSubmit={sendMessage}>
    <div className="input-wrapper-chat">
    <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Message LovingIS"
            rows="1"
            className="dynamic-textarea"
            onInput={handleTextareaResize}
        />
        <button className="enter-button" type="submit" disabled={!input.trim()}>
                                              <img src={sendIcon} />
                                
        </button>
    </div>
</form>
      </div>
    </div>
  );
};

export default UnauthenticatedChat;
